import { FronteggContext } from '@frontegg/rest-api';
import { Axios, AxiosAdmin } from 'src/lib';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  orgSettingLoadingSlice,
  getOrgSettingSlice,
} from '../slices/organizationsetting.slice';

export const getOrgSetting = (key) => {
  return async (dispatch) => {
    dispatch(orgSettingLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await Axios.get(`/organization_settings?key=${key}`, {
      headers,
    });
    if (result?.status === 200) {
      dispatch(getOrgSettingSlice(result?.data));
      dispatch(orgSettingLoadingSlice(false));
    } else {
      dispatch(getOrgSettingSlice(null));
      dispatch(orgSettingLoadingSlice(false));
    }
  };
};

export const putOrgSetting = (key, value) => {
  return async (dispatch) => {
    dispatch(orgSettingLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await Axios.put(
      `/organization_settings/user?key=${key}`,
      {
        settings: value,
      },
      {
        headers: headers,
      }
    );
    if (result?.status === 200 || result?.status === 201) {
      showToastSuccess('Organization setting updated successfully');
      dispatch(orgSettingLoadingSlice(false));
    } else {
      showToastError('Failed to update organization setting');
      dispatch(orgSettingLoadingSlice(false));
    }
  };
};

export const deleteUser = (org_id, practitioner_id) => {
  return async (dispatch) => {
    dispatch(orgSettingLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    const result = await AxiosAdmin.post(
      `/archive/user`,
      {
        org_id: org_id,
        practitioner_id: practitioner_id,
      },
      {
        headers: headers,
      }
    );
    if (result?.status === 200) {
      showToastSuccess('User deleted successfully');
      dispatch(orgSettingLoadingSlice(false));
    } else {
      showToastError('Failed to delete user');
      dispatch(orgSettingLoadingSlice(false));
    }
  };
};
